import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import ImgErxIllustration from '../../../../../../public/images/illustrations/illustration-erx.png'
import { useExperimentalAddStaticFileHost } from '../../../../../experiments/new-cdn-experiment/useExperimentalAddStaticFileHost'
import { useGlobalConfigContext } from '../../../../../global-config'
import { StaticImage } from '../../../../../image'
import {
  urlResolverGetFreeEnvelopePdf,
  urlResolverGetRedeemEprescription,
} from '../../../../../url-handling'
import { erxBonusLandingPageTextBreak } from '../../../../components/ErxBonusLandingPageTranslationValues'
import ImgPKVRezeptBlau from '../../../../images/ImgPKVRezeptBlau.png'

export const ErxBonusLandingPageTypesOfPrescriptions: FC = () => {
  const globalConfig = useGlobalConfigContext()

  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()

  const linkRedeemEprescription = (text: ReactNode[]): ReactElement => (
    <Link href={urlResolverGetRedeemEprescription(globalConfig)}>{text}</Link>
  )

  const linkRedeemPaperPrescription = (text: ReactNode[]): ReactElement => (
    <Link href={addStaticCdnHostToUrl(urlResolverGetFreeEnvelopePdf())}>
      {text}
    </Link>
  )

  const values = {
    break: erxBonusLandingPageTextBreak,
    linkRedeemEprescription,
    linkRedeemPaperPrescription,
  }

  return (
    <div className="pt-10">
      <div className="px-5 text-center text-2xl tablet:px-0">
        <FormattedMessage id="deErx.oldBonus.TypesOfPrescription.Heading" />
      </div>
      <div className="flex flex-col justify-between gap-6 pt-6 tablet:flex-row">
        <div className="flex flex-1 flex-col gap-6 rounded-lg border border-dark-primary-min p-6 tablet:flex-row">
          <div>
            <StaticImage
              alt="Kassenrezept"
              className="max-w-max"
              height={120}
              src={ImgErxIllustration}
              width={173}
            />
          </div>
          <div>
            <p className="text-m font-medium">
              <FormattedMessage id="deErx.oldBonus.TypesOfPrescription.normalPrescription.heading" />
            </p>
            <p>
              <FormattedMessage
                id="deErx.oldBonus.TypesOfPrescription.normalPrescription.description"
                values={values}
              />
            </p>
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-6 rounded-lg border border-dark-primary-min p-6 tablet:flex-row">
          <div>
            <StaticImage
              alt="Kassenrezept"
              className="max-w-max"
              height={120}
              src={ImgPKVRezeptBlau}
              width={173}
            />
          </div>
          <div>
            <p className="text-m font-medium">
              <FormattedMessage id="deErx.oldBonus.TypesOfPrescription.PrivatePrescription.heading" />
            </p>
            <p>
              <FormattedMessage
                id="deErx.oldBonus.TypesOfPrescription.PrivatePrescription.description"
                values={{
                  link: linkRedeemPaperPrescription,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
